import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setActiveNote, getMyJournals } from '../../../redux/reducers/journals';
// hoc
import { withRouter } from 'react-router-dom';
// components
import Placeholder from './Placeholder';
import NoteBlock from './NoteBlock';
import Preloader from '../../../components/Preloader/Preloader';
import Waypoint from 'react-waypoint';
// utils
import { toastResponseErrors } from '../../../utils/response';
// styles
import classnames from 'classnames/bind';
import styles from './MyJournals.mod.css';

let cx = classnames.bind(styles);

class MyJournals extends Component {
  onPagination = () => {
    const {
      getMyJournals,
      meta: { current },
      params: { per_page, filter }
    } = this.props;
    getMyJournals({
      per_page,
      page: current + 1,
      filter
    })
      .then(() => {
        window.scrollTo(0, this.scrollY);
      })
      .catch(toastResponseErrors);
  };

  componentWillReceiveProps() {
    this.scrollY = window.scrollY;
  }

  componentDidMount() {
    this.props.getMyJournals();
  }

  componentWillUnmount() {
    this.props.setActiveNote(null);
  }

  render() {
    const {
      myJournals,
      isLoading,
      params: { per_page },
      meta: { current, total },
      userColor
    } = this.props;

    const isWaypoint = total > current * per_page && !isLoading;
    const isBottomPreloader = current !== 0 && total >= per_page;

    return myJournals.length > 0 ? (
      <div className={cx('list-wrapper')}>
        {myJournals.map((note, index) => (
          <NoteBlock key={index} note={note} userColor={userColor} />
        ))}
        {isWaypoint && <Waypoint onEnter={this.onPagination} />}
        {isBottomPreloader && (
          <Preloader className={cx('preloader')} custom isActive={isLoading} />
        )}
      </div>
    ) : (
      <Placeholder>No items to display.</Placeholder>
    );
  }
}

MyJournals.propTypes = {
  className: T.string,
  myJournals: T.array.isRequired,
  isLoading: T.bool.isRequired
};

const enhance = compose(
  withRouter,
  connect(
    state => ({
      myJournals: state.journals.myJournals,
      isLoading: state.journals.isLoading,
      params: state.journals.params,
      meta: state.journals.meta
    }),
    { setActiveNote, getMyJournals }
  )
);

export default enhance(MyJournals);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/MyJournals.jsx